var map = {
	"./12hotpot.svg": "37b6",
	"./6owl door.svg": "b708",
	"./7-ELEVEN.svg": "b3d1",
	"./7-eleven_logo.svg": "fb5d",
	"./85Cafe.svg": "4f5d",
	"./ABV BAR & KITCHEN.svg": "c728",
	"./Anytime Fitness2.svg": "aea8",
	"./BOBO Coin Laundry.svg": "4916",
	"./Boa-Q.svg": "8d87",
	"./BravoBeer.svg": "b5b5",
	"./Burger King.svg": "171b",
	"./CHAU WEI JIUE.svg": "0f88",
	"./ChaForTea.svg": "81df",
	"./Chagether Yakiniku.svg": "2eb1",
	"./Chien Tu.svg": "e894",
	"./ChingShin.svg": "0538",
	"./CoCo.svg": "6f49",
	"./ComeBuy.svg": "54cd",
	"./CooCooG Pet.svg": "32eb",
	"./Curves.svg": "f749",
	"./DEXTER.svg": "3450",
	"./Da Pu Teppanyaki.svg": "029d",
	"./DayUngs.svg": "f7e5",
	"./Dominos.svg": "34f9",
	"./Dr. Washing.svg": "6779",
	"./ETpet.svg": "7df8",
	"./Extreme Fitness Center.svg": "ec41",
	"./Family Mart.svg": "ba69",
	"./Fatdaddy fried chicken.svg": "d8d1",
	"./FitnessFactory-01.svg": "d68c",
	"./Fmsc.svg": "be1e",
	"./GBA.svg": "ae9a",
	"./Gaibom.svg": "8e1f",
	"./GoodTime2.svg": "6f93",
	"./Great Tree.svg": "1c94",
	"./Gyu-Kaku.svg": "af0d",
	"./HAPPYHAIR.svg": "f125",
	"./HOT-STAR.svg": "d857",
	"./HWC Roasters.svg": "22ac",
	"./Hi-Life.svg": "c503",
	"./Hi-Life_logo.svg": "cd60",
	"./HongYaC.svg": "62ae",
	"./Hu Tong.svg": "d917",
	"./IJYSHENG.svg": "3a14",
	"./JHUJIAN.svg": "60d6",
	"./J＆G Fried Chicken-01.svg": "4c04",
	"./J＆G Fried Chicken.svg": "6840",
	"./KEBUKE Tea.svg": "cf7b",
	"./KFC.svg": "5576",
	"./Kanpa Iyakiniku.svg": "a3d3",
	"./LE BLE D’OR.svg": "cd46",
	"./LIANG SHE HAN BUY GOOD.svg": "bd77",
	"./LOUISA COFFEE.svg": "22b7",
	"./Lan50.svg": "52c5",
	"./LayaBurger.svg": "d8df",
	"./Lima Hotpot.svg": "8f12",
	"./LouisaCoffee.svg": "0f57",
	"./MACU TEA.svg": "14ca",
	"./MILAN HAIR SALON.svg": "02ac",
	"./MOS Burger.svg": "90bc",
	"./Macc.svg": "b7d0",
	"./Mam.svg": "5dad",
	"./Man.svg": "0e03",
	"./McDonalds.svg": "83a6",
	"./MedFirst.svg": "1117",
	"./MilkShopTea.svg": "8e52",
	"./Monga.svg": "c02d",
	"./Mr. Mark.svg": "2c68",
	"./Mwd.svg": "6aa4",
	"./Napoli.svg": "6a06",
	"./OK MART.svg": "9e09",
	"./OK_logo.svg": "3bec",
	"./OLDGOD Mini.svg": "5a54",
	"./OLDGOD.svg": "3b71",
	"./OhOhYes.svg": "4e33",
	"./Oscar Pet.svg": "2161",
	"./Other Bistro.svg": "140d",
	"./Other Pizza.svg": "d3b9",
	"./PetPark.svg": "2bd4",
	"./Pets Family.svg": "c66a",
	"./Pizza Hut.svg": "cb18",
	"./Pizza Rock.svg": "633c",
	"./QB HOUSE.svg": "52d1",
	"./QBurger.svg": "ca9f",
	"./QiaoFu.svg": "41d8",
	"./SEATER.svg": "96a0",
	"./SHOW LIN Beauty Salon.svg": "941b",
	"./SUBWAY.svg": "7ccf",
	"./Schumann's Bistro-01.svg": "2d0c",
	"./Schumann's Bistro.svg": "5d67",
	"./SeSA Coin Laundry.svg": "6eda",
	"./Shopee2.svg": "29d5",
	"./Simple Mart.svg": "7a00",
	"./Sioumazang Yakiniku.svg": "4630",
	"./Speedy Laundry.svg": "7855",
	"./Suabu Family.svg": "f0df",
	"./Sunmerry.svg": "64b2",
	"./THSR.svg": "5e0f",
	"./TKK Fried Chicken.svg": "ec4a",
	"./TKK.svg": "532d",
	"./ThreeMotherPot.svg": "5aaf",
	"./TinTin Drugstore.svg": "244f",
	"./Tino's Pizza Café2.svg": "7021",
	"./TpTea.svg": "4335",
	"./TwJsp.svg": "1165",
	"./Two Peck.svg": "34bc",
	"./Way8.svg": "7811",
	"./Wellcare.svg": "508e",
	"./William Beauty Salon.svg": "9de0",
	"./World Gym.svg": "d445",
	"./Wu Tau.svg": "a531",
	"./YAMAZAKI.svg": "7e8a",
	"./YES CHAIN.svg": "823b",
	"./Yakiyan.svg": "2080",
	"./YuLoong.svg": "1db5",
	"./brand/getcheeLog-m.svg": "1e21",
	"./brand/logo.svg": "dc71",
	"./cama café.svg": "8633",
	"./camaCafe.svg": "f634",
	"./dante.svg": "c9bc",
	"./donutes.svg": "3ffd",
	"./exclamation-mark.svg": "3e03",
	"./familymart_logo.backup.svg": "967c",
	"./familymart_logo.svg": "e3fe",
	"./gps.svg": "a0263",
	"./licenseSeats.svg": "d33d",
	"./line-graph.svg": "d5d3",
	"./magnifying-glass.svg": "c917",
	"./maps/QA_pin.svg": "b71e",
	"./maps/QA_pin02.svg": "b780",
	"./maps/QA_pin03.svg": "df24",
	"./maps/QA_pin04.svg": "81a7",
	"./mentor.svg": "9be1",
	"./metro.svg": "0521",
	"./milkHouses.svg": "6fa2",
	"./note.svg": "6fd3a",
	"./petsmall2.svg": "17c5",
	"./question.svg": "5b7c",
	"./questionW.svg": "9301",
	"./questionnaire-icon.svg": "7068",
	"./rododo.svg": "9f59",
	"./share.svg": "6d47",
	"./starbucks.svg": "5422",
	"./taiwan_Railways.svg": "714b",
	"./triangle1.svg": "e017",
	"./triangle2.svg": "057f",
	"./yourchance.svg": "3fd4",
	"./五鮮級平價鍋物.svg": "c1e5",
	"./佳湘麵包.svg": "9e87"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b464";